import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private apiUrl = `${environment.apiBaseUrl}/notifications`;

  constructor(private http: HttpClient) { }

  getNotifications(): Observable<any[]> {
    // Implementar cuando la API esté disponible
    // return this.http.get<any[]>(this.apiUrl);
    
    // Datos de prueba mientras tanto
    return of([
      {
        id: 1,
        title: 'Notificación importante',
        message: 'Este es un mensaje importante para todos los usuarios',
        date: new Date(),
        isRead: false,
        importance: 'alta'
      },
      {
        id: 2,
        title: 'Actualización de sistema',
        message: 'El sistema estará en mantenimiento este fin de semana',
        date: new Date(Date.now() - 86400000),
        isRead: true,
        importance: 'media'
      }
    ]);
  }

  createNotification(notification: any): Observable<any> {
    // Implementar cuando la API esté disponible
    // return this.http.post<any>(this.apiUrl, notification);
    
    // Simulación de respuesta
    return of({ success: true, id: Math.floor(Math.random() * 1000) });
  }

  getNotificationById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  /**
   * Crear notificación masiva (broadcast)
   */
  createBroadcastNotification(notificationData: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/broadcast`, notificationData);
  }

  /**
   * Obtener todas las notificaciones (admin)
   */
  getAllNotifications(skip: number = 0, limit: number = 100): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/admin/all`, {
      params: { skip: skip.toString(), limit: limit.toString() }
    });
  }

  /**
   * Obtener estadísticas de notificaciones de un usuario
   */
  getNotificationStats(userId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/stats/${userId}`);
  }
}
